exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dmb-web__ModalWrapper__modalWrapper__I6kFg {\n  background-color: rgb(0 0 0 / 60%);\n  height: 100%;\n  left: 0;\n  position: fixed;\n  top: 0;\n  width: 100%;\n  z-index: 1;\n}\n\n.dmb-web__ModalWrapper__modalContent__bYcxD {\n  background-color: white;\n  left: 50%;\n  padding: 40px;\n  position: absolute;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  top: 30%;\n}", ""]);

// exports
exports.locals = {
	"modalWrapper": "dmb-web__ModalWrapper__modalWrapper__I6kFg",
	"modalContent": "dmb-web__ModalWrapper__modalContent__bYcxD"
};